import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const ServiciosPage = lazy(() => import("../pages/servicios/page"));
const ContactoPage = lazy(() => import("../pages/contacto/page"));
const CustomSolutionsPage = lazy(
  () => import("../pages/soluciones-a-medida/page"),
);
const DemoPage = lazy(() => import("../pages/demo/page"));
const AvisoLegalPage = lazy(() => import("../pages/legal/aviso-legal/page"));
const PrivacidadPage = lazy(() => import("../pages/legal/privacidad/page"));
const CookiesPage = lazy(() => import("../pages/legal/cookies/page"));
const PoliticaCookiesPage = lazy(
  () => import("../pages/legal/politica-cookies/page"),
);
const NotFoundPage = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/servicios",
    element: <ServiciosPage />,
  },
  {
    path: "/soluciones-a-medida",
    element: <CustomSolutionsPage />,
  },
  {
    path: "/demo",
    element: <DemoPage />,
  },
  {
    path: "/contacto",
    element: <ContactoPage />,
  },
  {
    path: "/legal/aviso-legal",
    element: <AvisoLegalPage />,
  },
  {
    path: "/legal/privacidad",
    element: <PrivacidadPage />,
  },
  {
    path: "/legal/cookies",
    element: <CookiesPage />,
  },
  {
    path: "/politica-cookies",
    element: <PoliticaCookiesPage />,
  },
  {
    path: "/en",
    element: <HomePage />,
  },
  {
    path: "/en/services",
    element: <ServiciosPage />,
  },
  {
    path: "/en/custom-solutions",
    element: <CustomSolutionsPage />,
  },
  {
    path: "/en/demo",
    element: <DemoPage />,
  },
  {
    path: "/en/contact",
    element: <ContactoPage />,
  },
  {
    path: "/en/legal/privacy",
    element: <PrivacidadPage />,
  },
  {
    path: "/en/legal/cookies",
    element: <CookiesPage />,
  },
  {
    path: "/en/legal/notice",
    element: <AvisoLegalPage />,
  },

  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;
